import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class MilitiaBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MILITIA;
}

export default MilitiaBuildingTileEntity;
